// extracted by mini-css-extract-plugin
export var actionText = "_pv-4";
export var container = "_pv-0";
export var leftSection = "_pv-1";
export var rightSection = "_pv-2";
export var settingsButton = "_pv-6";
export var settingsIcon = "_pv-7";
export var shortcut = "_pv-5";
export var shortcutGroup = "_pv-3";